import { Component, Input, OnInit, Type } from '@angular/core';
import { CardView } from 'src/app/interfaces/cardview';
import { REGISTRY } from 'src/app/interfaces/registry-services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { MeliEditFormComponent } from '../../produtos/mercadolivre/meli-edit-form/meli-edit-form.component';

@Component({
    selector: 'generic-marketplace-tab',
    templateUrl: './generic-tab.component.html',
    styleUrls: ['./generic-tab.component.scss'],
    standalone: false
})
export class GenericTabComponent implements OnInit {

  constructor() { }

  @Input() component:string;
  @Input() parentRow:CardView;
  @Input() entityName:string;
  @Input() templateId: number | null = null;
  condition:string;
  public comp:Type<any> = null;

  /** Template ID para modo inclusão. Vem da configuração da aba (preferência do usuário). */
  get templateIdForAdd(): number | null {
    return this.templateId ?? null;
  }

  ngOnInit(): void {
    if ( this.component!= null ){
      this.comp = REGISTRY.get(this.component);
    }
    
    if ( ObjectUtil.isNotEmpty(this.parentRow)){
      //this.condition = `codecontract=${this.parentRow.linha['CODECONTRACT']} and codeproduct=${this.parentRow.linha['CODEPRODUCT']}` 
      this.condition = `this.codecontract=${this.parentRow.linha['CODECONTRACT']} and this.codeproduct=${this.parentRow.linha['CODEPRODUCT']}` //jdbc
    }
    
  }

}
